import { PaperAirplaneIcon, PlusCircleIcon } from "@heroicons/react/24/solid";
import React, { useContext, useState } from "react";
import { portfolioConfig } from "../config/portfolio.config";
import { ThemeContext } from "../contexts/ThemeContext";

const Messages = () => {
  const [conversations, setConversations] = useState(
    portfolioConfig.initialConversations
  );
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState({});
  const { darkMode } = useContext(ThemeContext);

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (message.trim() && selectedConversation) {
      const newMessages = {
        ...messages,
        [selectedConversation.id]: [
          ...(messages[selectedConversation.id] || []),
          { text: message, sender: "me" },
        ],
      };
      setMessages(newMessages);
      setMessage("");
    }
  };

  const startNewConversation = () => {
    const newConversation = {
      id: conversations.length + 1,
      user: "New Contact",
      lastMessage: "",
      avatar: "https://source.unsplash.com/100x100/?portrait&new",
    };
    setConversations([newConversation, ...conversations]);
    setSelectedConversation(newConversation);
  };

  return (
    <div className="max-w-6xl mx-auto px-4 flex h-[calc(100vh-64px)]">
      {/* Conversation List */}
      <div className="w-1/3 overflow-y-auto border-r">
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-xl font-semibold">Messages</h2>
          <button onClick={startNewConversation} className="text-blue-500">
            <PlusCircleIcon className="w-6 h-6" />
          </button>
        </div>
        {conversations.map((conv) => (
          <div
            key={conv.id}
            className={`p-4 border-0 cursor-pointer ${
              darkMode ? "hover:bg-gray-900" : "hover:bg-gray-100"
            } ${
              selectedConversation?.id === conv.id
                ? darkMode
                  ? "bg-gray-900"
                  : "bg-gray-100"
                : ""
            }`}
            onClick={() => setSelectedConversation(conv)}
          >
            <div className="flex items-center">
              <img
                src={conv.avatar}
                alt={conv.user}
                className="w-12 h-12 mr-4 rounded-full"
              />
              <div>
                <h3 className="font-semibold">{conv.user}</h3>
                <p className="text-sm text-gray-600">{conv.lastMessage}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Chat Interface */}
      <div className="flex flex-col w-2/3">
        {selectedConversation ? (
          <>
            <div className="p-4 border-1">
              <h2 className="text-xl font-semibold">
                {selectedConversation.user}
              </h2>
            </div>
            <div className="flex-grow p-4 overflow-y-auto">
              {messages[selectedConversation.id]?.map((msg, index) => (
                <div
                  key={index}
                  className={`mb-4 ${msg.sender === "me" ? "text-right" : ""}`}
                >
                  <span
                    className={`inline-block p-2 rounded-lg ${
                      msg.sender === "me"
                        ? "bg-blue-500 text-white"
                        : "bg-gray-200"
                    }`}
                  >
                    {msg.text}
                  </span>
                </div>
              ))}
            </div>
            <form onSubmit={handleSendMessage} className="flex p-4 border-0">
              <input
                type="text"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Type a message..."
                className={`${
                  darkMode ? "bg-gray-800" : "bg-white"
                } flex-grow px-4 py-2 border-1 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500`}
              />
              <button
                type="submit"
                className="p-2 ml-2 text-white bg-blue-500 rounded-full"
              >
                <PaperAirplaneIcon className="w-6 h-6" />
              </button>
            </form>
          </>
        ) : (
          <div className="flex items-center justify-center h-full text-gray-500">
            Select a conversation or start a new one
          </div>
        )}
      </div>
    </div>
  );
};

export default Messages;
